import Vue from 'vue';
import VueRouter from 'vue-router';
import { updateTDK } from '@/utils/seo-config';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/web/' : process.env.BASE_URL,
  routes,
});

// 路由守卫：根路径根据设备类型跳转
function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

router.beforeEach((to, from, next) => {
  // 仅在从根路径进入时判断（包含从 "/" 重定向而来的情况）
  const fromRoot = to.path === '/' || to.redirectedFrom === '/';

  if (fromRoot) {
    if (isMobileDevice()) {
      if (to.path !== '/mobile') {
        next('/mobile');
        return;
      }
    } else if (to.path !== '/index') {
      next('/index');
      return;
    }
  }

  next();
});

// 百度统计 - SPA 路由变化时触发页面浏览统计
router.afterEach((to) => {
  // TDK 动态更新
  updateTDK(to.path);
  // 百度统计
  // eslint-disable-next-line no-underscore-dangle
  const hmt = typeof window !== 'undefined' ? window._hmt : null;
  if (hmt) {
    // 获取完整路径（hash 模式下包含 #）
    const path = to.fullPath || to.path;
    hmt.push(['_trackPageview', path]);
  }
});

export default router;
